import { Board, BoardParticipant, Partner } from 'types';

export const getSelectablePartners = (
  board: Board,
  partners: Partner[],
  actualPartner: BoardParticipant
): Partner[] =>
  partners.filter((partner) => {
    const participant = board?.participants?.find(
      (currentParticipant) => currentParticipant.member === partner['_id']
    );

    return (
      partner['_id'] === actualPartner?.representative &&
      !!participant &&
      !participant.isRepresented &&
      (participant?.votes?.length || 0) === 0
    );
  }) || [];
